import clsx from "clsx";
import React, { useMemo } from "react";
import { useBreakPoint } from "../../../../hook/useBreakPoint";
import classes from "./result.module.css";
export const InfoResult = ({
  scanResult: {
    code,
    message,
    ticketCode,
    barcode,
    visitorName,
    visitorPhoto,
    category,
    title,
    position,
    nationality,
    organization,
    productName,
    seatRow,
    seatNo,
    locationSlug,
  },
}) => {
  const { down } = useBreakPoint();
  const isMobile = useMemo(() => {
    return down("xs");
  }, [down]);

  return (
    <div className="px-0 mx-0">
      {message && (
        <div className="px-0 mt-3">
          <p className="text-danger">{message}</p>
        </div>
      )}

      {/* TICKET ID */}
      {barcode && (
        <div className="px-0 mt-3">
          <span className="text-light fs-6">{barcode}</span>
        </div>
      )}

      {code && (
        <div className="px-0 mt-3">
          <span className="text-light fs-6">{code}</span>
        </div>
      )}

      {/* NAME - POSTISION - ORGANIZATION */}

      {visitorName && (
        <div
          className={clsx(
            "display-flex-row d-flex flex-row flex-wrap-content justify-content-between w-100 px-0 mt-2",
            classes.infoContainer
          )}
        >
          <div className="d-flex flex-row">
            {visitorPhoto && (
              <div className="w-25 me-3">
                <img
                  width="100%"
                  src={
                    visitorPhoto
                      ? visitorPhoto
                      : "./assets/images/defaultImage.png"
                  }
                  alt="visitorPhoto"
                />
              </div>
            )}

            <div className="w-100">
              <span className="badge bg-info text-light">{category}</span>
              <p
                className={`text-light ${
                  isMobile ? "fs-4" : "fs-1"
                } text-uppercase w-auto`}
              >
                {title && <span>{title + " "}</span>}
                {visitorName}
              </p>

              {position && (
                <p className={`text-secondary ${!isMobile && "fs-5"}`}>
                  {position}
                </p>
              )}
              {organization && (
                <p className={`text-secondary ${!isMobile && "fs-5"}`}>
                  {organization}
                </p>
              )}

              {nationality && (
                <p className={`text-secondary ${!isMobile && "fs-5"}`}>
                  {nationality}
                </p>
              )}

              {productName && (
                <p className={`text-secondary ${!isMobile && "fs-5"}`}>
                  {productName}
                </p>
              )}

              {seatRow && seatNo && locationSlug && (
                <p
                  className={`text-secondary text-uppercase ${
                    !isMobile && "fs-5"
                  }`}
                >
                  {`Section ${locationSlug} ${seatRow}${seatNo}`}
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
